module.exports = __webpack_public_path__ + "static/media/logo.49d04bdf.jpg";